export default "__VITE_ASSET__DXXdBz7p__"